import { render, staticRenderFns } from "./block-promotions.vue?vue&type=template&id=8b6e20ee&scoped=true"
import script from "./block-promotions.vue?vue&type=script&lang=js"
export * from "./block-promotions.vue?vue&type=script&lang=js"
import style0 from "./block-promotions.vue?vue&type=style&index=0&id=8b6e20ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e20ee",
  null
  
)

export default component.exports